import React, { useState } from 'react';
import { Users, ChevronDown, ChevronUp } from 'lucide-react';
import { missedLabel } from '../utils/classGaps';
import { ui } from '../ui';

/**
 * The facilitator's view of what the room collectively missed on a step,
 * written at Merge & share or Reveal (see utils/classGaps.js). A plain list:
 * the item, "Missed by 9 of 12" right-aligned as the loudest thing on the
 * row, and a thin bar beneath showing the miss proportion. Worst first.
 */
export default function ClassGapsPanel({ gaps, scopeLabel }) {
  const [open, setOpen] = useState(true);
  if (!gaps || !gaps.items?.length) return null;
  const { total, items } = gaps;
  const missedAny = items.filter((i) => i.missed > 0).length;

  return (
    <div className={`${ui.panel} mt-section`} data-testid="class-gaps">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2 text-heading font-medium text-ink">
          <Users className="w-4 h-4 text-ink-2" />
          Class gaps{scopeLabel ? `: ${scopeLabel}` : ''}
          <span className="text-meta font-normal text-ink-2">
            {missedAny} of {items.length} expert items missed by someone, {total} student{total === 1 ? '' : 's'} counted
          </span>
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-ink-2" /> : <ChevronDown className="w-4 h-4 text-ink-2" />}
      </button>
      {open && (
        <ul className="px-4 pb-3">
          {items.map((item) => {
            const fraction = total ? item.missed / total : 0;
            return (
              <li key={item.text} className="py-2 border-t border-line first:border-t-0">
                <div className="flex items-baseline justify-between gap-4">
                  <span className="text-body font-medium text-ink min-w-0 truncate">{item.text}</span>
                  <span className="text-body font-semibold text-ink tabular-nums flex-shrink-0">
                    {missedLabel(item, total)}
                  </span>
                </div>
                <div className="h-0.5 mt-1.5 rounded-full bg-line overflow-hidden" aria-hidden="true">
                  <div className="h-full bg-accent" style={{ width: `${Math.round(fraction * 100)}%` }} />
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
